<template>
  <div v-if="!toTopClose" class="toTopFab text-center">
    <v-fab-transition>
      <v-btn
        v-show="showFab"
        @click="toTop"
        v-scroll="onScroll"
        fab
        dark
        color="#fdda24"
      >
        <v-icon large>mdi-chevron-up</v-icon>
      </v-btn>
    </v-fab-transition>
    <!-- <br />
    <v-slide-y-transition>
      <div v-show="showFab" class="primary-1--text mt-2 font-weight-bold">
        TOP
      </div>
    </v-slide-y-transition> -->
  </div>
</template>

<script>
export default {
  name: "TheLayoutToTopFab",
  data: () => ({
    showFab: false
  }),
  computed: {
    toTopClose() {
      return this.$route.meta.order;
    }
  },
  methods: {
    onScroll() {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || document.documentElement.offsetTop || 0;
      this.showFab = top > 0;
    },
    toTop() {
      this.$vuetify.goTo(0);
    }
  }
};
</script>

<style lang="scss" scoped>
.toTopFab {
  position: fixed;
  bottom: 16px;
  right: 16px;
  z-index: 4;
}
</style>
